// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { jsx } from '@emotion/core';

import { type Node } from 'react';

type Props = {
  children: Node,
  title: string,
};

const headingCss = {
  color: Colors.deepSpace,
  fontSize: '1.2em',
  fontWeight: 600,
  marginBottom: '1em',
  marginTop: '2em',
  padding: 0,
};

const sectionCss = {
  marginBottom: '2em',
};

const ChangePlanSection = (props: Props) => (
  <section css={sectionCss}>
    <h2 css={headingCss}>{props.title}</h2>
    {props.children}
  </section>
);

export default ChangePlanSection;
